"use strict";

import {waitForDependencies } from '../_imports/utils/utils.common';
import { prepareVideos } from '../../api/media/video';
import tippy from 'tippy.js';
import { initializeToolTips } from '../../utils/utils';


const addIntersectionObserverOnBanners = () => {
	const containers = document.querySelectorAll('[data-banner-alternator]');

	containers.forEach((bannerAlternator) => {
		const abstractBanners = bannerAlternator.querySelectorAll('[data-component="cta-abstract-banner"]');
		bannerAlternator.style.backgroundColor = abstractBanners[0].dataset.backgroundColor;

		const option = {
			root: null,
			rootMargin: '50px',
			threshold: 0.8,
		};

	const observer = new IntersectionObserver(
		function(entries) {
			entries.forEach(entry => {
			
				if (entry.isIntersecting && (Math.round(entry.intersectionRatio) === 1)) {
					entry.target.classList.add('visible');
					bannerAlternator.style.background = entry.target.dataset.backgroundColor;
				} 
			});
		}, option);

		abstractBanners.forEach((banner) => {
			observer.observe(banner);
		});
	});
}

waitForDependencies(() => {
	prepareVideos();
       
	if (document.querySelector('html').dataset.page.includes('home')) {
		addIntersectionObserverOnBanners();
	}
	
	initializeToolTips(tippy);
});

